<div class="QRCode  ub ub-ver" :style="{'width':width+'px', 'height':height+'px'}">
  <canvas :id="canvasId" :style="{'width':width+'px', 'height':height+'px',position:'absolute',opacity:0}" ></canvas>
  <img :src="url" :style="{'width':width+'px', 'height':height+'px'}"/>
</div>